// Extraído do MontadorPistaHipismo.vue — utilitários numéricos e listas (pt-BR)

export function toDecimalBR(n, digits = 2){
  if (n == null || n === '') return '';
  const num = Number(n);
  if (!Number.isFinite(num)) return '';
  return num.toFixed(digits).replace('.', ',');
}

export function parseNumberBR(s){
  const t = String(s ?? '').trim().replace(/\./g, ',');
  if (!t) return NaN;
  return Number(t.replace(',', '.'));
}

// Durante a digitação: mantém números, vírgula decimal e ';' como separador
export function normalizeListInputLive(str) {
  let s = String(str ?? '');
  s = s.replace(/\./g, ',');           // 1.2 -> 1,2
  s = s.replace(/[^0-9,;\s-]/g, '');   // só dígitos, vírgula, ';', espaço e sinal
  s = s.replace(/\s*;\s*/g, '; ');     // normaliza espaços ao redor do ';'
  s = s.replace(/;{2,}/g, ';');        // evita ';;'
  s = s.replace(/(\d),+(\d)/g, '$1,$2'); // evita '1,,2'
  return s;
}

// Ao sair do campo: remove separador final e espaços excedentes
export function finalizeListInput(str) {
  let s = normalizeListInputLive(str);
  s = s.trim();
  s = s.replace(/[;,\s]+$/, '');       // remove ';' ou ',' no fim
  s = s.replace(/\s*;\s*/g, '; ');
  return s;
}

// String -> números (aceita ';' como separador e vírgula como decimal; tolera '1.2')
export function parseNumberList(str) {
  let s = String(str ?? '').trim();
  if (!s) return [];

  // 1) Normaliza: aceita ponto como decimal legada -> vírgula
  s = s.replace(/\./g, ',');

  // 2) Trata lista legada "0,10, 0,10, 0,10":
  //    converte vírgula + espaço (separador de lista) em ';' e mantém vírgula decimal.
  s = s.replace(/,\s+(?=\d)/g, ';');   // ", " seguido de dígito => separador

  // 3) Normaliza ';' como separador oficial
  s = s.replace(/\s*;\s*/g, ';');

  // 4) Divide e converte para Number (vírgula decimal -> ponto)
  return s
    .split(';')
    .map(v => v.trim())
    .filter(Boolean)
    .map(v => Number(v.replace(',', '.')))
    .filter(Number.isFinite);
}

export function formatListSemicolon(arr, digits = 2) {
  return (arr || [])
    .map(v => toDecimalBR(v, digits))
    .filter(Boolean)
    .join('; ');
}

// Converte alturas absolutas + espessuras -> vãos (sempre >= 0)
export function heightsToGaps(heights = [], thicks = []) {
  const H = heights.map(n => Number(n));
  const T = thicks.map(n => Number(n));
  const n = Math.min(H.length, T.length);
  const out = [];
  for (let i = 0; i < n - 1; i++) {
    // vão = diferença de alturas de centro a centro – meia espessura de cada barra adjacente
    const g = (H[i + 1] - H[i]) - (T[i] / 2 + T[i + 1] / 2);
    out.push(Math.max(0, +g.toFixed(3))); // nunca negativo
  }
  return out;
}

// ⬇️ adicione no final (ou onde guarda seus helpers)
export function parseDecimalBR(input) {
  if (input == null) return NaN;
  if (typeof input === 'number') return input;
  // aceita "99,99" ou "99.99" e ignora separador de milhar
  const s = String(input).trim().replace(/\s+/g, '');
  const normalized = s.replace(/\./g, '').replace(',', '.'); // "1.234,56" -> "1234.56"
  const v = Number(normalized);
  return Number.isFinite(v) ? v : NaN;
}

export function formatDecimalBR(value, digits = 2) {
  const v = Number(value);
  return Number.isFinite(v) ? v.toFixed(digits).replace('.', ',') : '';
}
